import React, { createContext, useContext, useState } from "react";

const FolderContext = createContext();

export const FolderProvider = ({ children }) => {
  const [selectedFolder, setSelectedFolder] = useState(null);

  const selectFolder = (folder) => {
    console.log("Folder selected in context:", folder);
    setSelectedFolder(folder);
  };

  return (
    <FolderContext.Provider value={{ selectedFolder, selectFolder }}>
      {children}
    </FolderContext.Provider>
  );
};

export const useFolder = () => {
  const context = useContext(FolderContext);
  if (!context) {
    throw new Error("useFolder must be used within a FolderProvider");
  }
  return context;
};
